import styles from './O_CapsuleCommentMobilePost.module.css';
import O_CapsuleCommentsPost from '../O_CapsuleCommentsPost/O_CapsuleCommentsPost';
import { MockPost } from '@/mocks';
import { ScenarioReaction } from '@/services/capsulesApi';

interface O_CapsuleCommentMobilePostProps {
  isOpen: boolean;
  onClose: () => void;
  capsule: MockPost;
  comment?: ScenarioReaction | null;
  commentCount: number;
  plantCount: number;
  isAuthenticated: boolean;
  canComment: boolean;
  commentDraft: string;
  onCommentDraftChange: (value: string) => void;
  onCommentSubmit: () => void;
  canReply: boolean;
  replyDraft: string;
  onReplyDraftChange: (value: string) => void;
  onReplySubmit: () => void;
}

export default function O_CapsuleCommentMobilePost({
  isOpen,
  onClose,
  capsule,
  comment,
  commentCount,
  plantCount,
  isAuthenticated,
  canComment,
  commentDraft,
  onCommentDraftChange,
  onCommentSubmit,
  canReply,
  replyDraft,
  onReplyDraftChange,
  onReplySubmit,
}: O_CapsuleCommentMobilePostProps) {
  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} onClick={event => event.stopPropagation()}>
        <div className={styles.handle} />
        <div className={styles.content}>
          <O_CapsuleCommentsPost
            capsule={capsule}
            comment={comment}
            commentCount={commentCount}
            plantCount={plantCount}
            isAuthenticated={isAuthenticated}
            canComment={canComment}
            commentDraft={commentDraft}
            onCommentDraftChange={onCommentDraftChange}
            onCommentSubmit={onCommentSubmit}
            canReply={canReply}
            replyDraft={replyDraft}
            onReplyDraftChange={onReplyDraftChange}
            onReplySubmit={onReplySubmit}
          />
        </div>
      </div>
    </div>
  );
}
